import { Component, EventEmitter, Output, Input, AfterContentInit, ViewChildren, QueryList, Inject } from '@angular/core';
import { MobileMenuItemComponent } from '../mobile-menu-item/mobile-menu-item.component';
import { DOCUMENT } from '@angular/common';

@Component({
  standalone: false,
  selector: 'mobile-menu',
  templateUrl: './mobile-menu.component.html',
  styleUrls: ['./mobile-menu.component.scss']
})
export class MobileMenuComponent implements AfterContentInit {
  @Input() fillBackground: boolean;
  @Output() onClose = new EventEmitter<void>();
  @ViewChildren(MobileMenuItemComponent) items: QueryList<MobileMenuItemComponent>;

  constructor(@Inject(DOCUMENT) private readonly _document: any) {

  }

  ngAfterContentInit() {
    setTimeout(() => {
      const items = this._document.getElementsByTagName('mobile-menu-item') as any;
      for (let item of items) {
        item.addEventListener('click', () => this.close());
      }
    }, 0);
  }

  public close() {
    this.onClose.emit();
    window.scroll(0, 0);
  }
}
